import roundOrderValue from '../common/roundOrderValue';
import checkIfCheckoutOrderExceedEstimatedValue from './checkIfCheckoutOrderExceedEstimatedValue';
import { Validator } from '../Validator';
import validate from '../validate';
import checkIfCheckoutOrderIsAvailable from './checkIfCheckoutOrderIsAvailable';

const configuration: Validator[] = [roundOrderValue, checkIfCheckoutOrderIsAvailable, checkIfCheckoutOrderExceedEstimatedValue];

export default validate(configuration);



// WEBPACK FOOTER //
// ./src/domain/orders/validators/checkout/index.ts